<template>
	<!-- banner -->
	<section v-if="topoBanner != ''" class="home-section hero"
		:style="{ backgroundImage: 'url(' + $imgURL + topoBanner[0].insInstitucionalImagens[0].itgUrlImagem + ')' }">
		<div class="row d-flex texto-banner-internas">
			<div class="container">
				<p class="titulo-cel">{{ topoBanner[0].itiNome }}</p>
			</div>
		</div>
	</section>
	<!-- END banner -->

	<!-- contato -->
	<section class="ftco-section contact-section ftco-no-pb">
		<div v-if="contato !=''" class="container">
			<div class="row justify-content-center mb-5 pb-3">
				<div class="col-md-7 heading-section text-center">
					<span class="subheading">{{ contato[0].itiNome }}</span>
					<h2 class="mb-4">{{ contato[0].itiReferencia }}</h2>
				</div>
			</div>

			<!-- formulario e endereço -->
			<div class="row block-9">
				<!-- formulario -->
				<div class="col-md-8">
					<form action="#" class="bg-light p-4 p-md-5 contact-form">
						<div class="row">
							<div class="col-md-6">
								<div class="form-group">
									<input v-model="formulario.nome" type="text" class="form-control"
										placeholder="Nome">
								</div>
							</div>
							<div class="col-md-6">
								<div class="form-group">
									<input v-mask="'(##) #####-####'" v-model="formulario.telefone" type="text"
										class="form-control" placeholder="Telefone">
								</div>
							</div>
							<div class="col-md-12">
								<div class="form-group">
									<input v-model="formulario.email" type="text" class="form-control"
										placeholder="E-mail">
								</div>
							</div>
							<div class="col-md-12">
								<div class="form-group">
									<textarea v-model="formulario.mensagem" name="" id="" cols="30" rows="7"
										class="form-control" placeholder="Mensagem"></textarea>
								</div>
							</div>
							<div class="col-md-12">
								<button type="submit" class="btn btn-primary py-3 px-5"
									@click.prevent="enviaremail()">Enviar Contato</button>
							</div>
						</div>
					</form>
				</div>
				<!-- END formulario -->

				<!-- endereços -->
				<div class="col-md-4 d-flex pl-md-5 endereco-top">
					<div class="row">
						<div class="dbox w-100 d-flex">
							<div class="icon d-flex align-items-center justify-content-center">
								<span class="fa fa-map-marker"></span>
							</div>
							<div class="text">
								<p v-html="contato[0].itiResumo1"></p>
							</div>
						</div>
						<div class="dbox w-100 d-flex">
							<div class="icon d-flex align-items-center justify-content-center">
								<span class="fa fa-phone"></span>
							</div>
							<div class="text">
								<p v-html="contato[0].itiResumo2"></p>
							</div>
						</div>
						<div class="dbox w-100 d-flex">
							<div class="icon d-flex align-items-center justify-content-center">
								<span class="fa fa-paper-plane"></span>
							</div>
							<div class="text">
								<p v-html="contato[0].itiDescricao1"></p>
							</div>
						</div>
					</div>
					<!-- <div id="map" class="map"></div> -->
				</div>
			</div>
		</div>
	</section>
	<!-- END contato -->

	<!-- mapa -->
	<section>
    <iframe v-if="contato != ''" :src="'https://www.google.com/maps/embed/v1/place?key=AIzaSyDmXp4J53f9Wt7iHX7dzIn7rHG7yL-EXXo&q=' + contato[0].itiCampoExtra2"
      width="100%" height="500px" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
	</section>
	<!-- END mapa -->

</template>

<script>
import { useHead } from '@vueuse/head'
import axios from 'axios'


export default {
	name: 'ContatoView',
	components: {

	},

	data: () => ({
		topoBanner: [],
		contato: [],

		formulario: {
			nome: "",
			telefone: "",
			email: "",
			mensagem: "",
		}

	}),

	methods: {

	enviaremail() {
      if (this.formulario.nome == '' || this.formulario.nome == null) {
        this.$mensagemErro('Nome obrigatório!');
      }
      else if (this.formulario.telefone == '' || this.formulario.telefone == null) {
        this.$mensagemErro('Telefone obrigatório!');
      }
      else if (this.formulario.email == '' || this.formulario.email == null) {
        this.$mensagemErro('E-mail obrigatório!');
      }
      else {
        let _dadosEmail = {
          nomeDe: this.formulario.nome,
          nomePara: "Induscapas",
          assunto: 'Contato do Site - ' + this.formulario.nome,
          destinatario: this.contato[0].itiCampoExtra1,
          emailResposta: this.formulario.email,
          textoEmail: "Nome: " + this.formulario.nome + "<br>"
            + "Telefone: " + this.formulario.telefone + "<br>"
            + "E-mail: " + this.formulario.email + "<br>"
            + "Mensagem: " + this.formulario.mensagem,

          nomeAnexo: '',
          anexo: '',
          tipoAnexo: ''
        }
		axios.post('/Process/AdmControleSmtp/Enviamail', _dadosEmail)
          .then(response => {
            if (response.data >= 1) {
              this.$mensagemSucesso("E-mail enviado com sucesso.")
              this.limparFormulario();
            }
          });
      }
    },

	limparFormulario() {
      this.formulario.nome = '';
      this.formulario.telefone = '';
      this.formulario.email = '';
      this.formulario.mensagem = '';
    },

		formataLink(value) {
			return value.replaceAll('/', '').replaceAll(' ', '-').replaceAll('.', '').replaceAll('+', '');
		},

		carregaMetas(texto) {
			useHead({
				title: 'Contato - Induscapas',
				meta: [
					{ name: "description", content: texto },
					{ name: "author", content: "Induscapas" },
					{ httpEquiv: "Content-Language", content: "pt-BR" },
					{ charset: "UTF-8" },
					{ name: "robots", content: "index, follow" },
				],
			})
		},

		toggleAccordion(index) {
			this.activeIndex = this.activeIndex === index ? null : index; // Alterna entre abrir e fechar o item
		},
	},

	created() {
		this.carregaMetas("---");

		//aqui busca o banner
		axios.get('/Process/InsInstitucional/institucional/15/contatotopo/0/x')
			.then(response => {
				this.topoBanner = response.data;
				//console.log('topo Banner')
				//console.log(this.topoBanner)
			})
			.catch(error => {
				console.error(error);
			});
		//aqui busca formulario
		axios.get('/Process/InsInstitucional/institucional/16/contato/0/x')
			.then(response => {
				this.contato = response.data;
				//console.log('formulario contato')
				//console.log(this.contato)
			})
			.catch(error => {
				console.error(error);
			});



	},
}

</script>

<style scoped></style>
